export const MACHINE_POWER_EVENT_KEY = "MACHINE_POWER_STATUS";

export function labelMachinePower(value) {
	if (value == null || value === "") {
		return null;
	}
	const text = String(value).trim().toUpperCase();
	if (text === "ON" || text === "1" || text === "801" || text === "MACHINE POWER ON") {
		return "ON";
	}
	if (text === "OFF" || text === "0" || text === "800" || text === "MACHINE POWER OFF") {
		return "OFF";
	}
	if (text === "UNKNOWN") {
		return "UNKNOWN";
	}
	return null;
}

function latestMachinePowerEvent(events) {
	if (!Array.isArray(events)) {
		return null;
	}
	let latest = null;
	for (const event of events) {
		let timeStamp = null;
		const modules = event?.modules || {};
		for (const moduleId in modules) {
			const systems = modules[moduleId]?.systems || {};
			for (const systemId in systems) {
				const stamp = systems[systemId]?.timestamp;
				if (stamp != null && (timeStamp == null || stamp > timeStamp)) {
					timeStamp = stamp;
				}
			}
		}
		if (!latest || (timeStamp != null && (latest.timeStamp == null || timeStamp > latest.timeStamp))) {
			latest = { value: event?.value, timeStamp };
		}
	}
	return latest;
}

export function resolveMachinePower(data) {
	const signals = [];
	const fromState = labelMachinePower(data?.kitchenStates?.["Machine Power"]?.value);
	const stateTimeStamp = data?.kitchenStates?.["Machine Power"]?.timeStamp ?? null;
	const onlineTimeStamp = data?.kitchenOnlineTimeStamp ?? null;
	const timeStamp = stateTimeStamp ?? onlineTimeStamp;
	const offline = data?.kitchenOnlineStatus === false || data?.kitchenOnlineStatus === 0;
	if (offline) {
		return { status: "UNKNOWN", timeStamp };
	}
	// Kitchen States is the stored value the status row is compared against.
	if (fromState === "ON" || fromState === "OFF") {
		return { status: fromState, timeStamp };
	}
	if (fromState) {
		signals.push({ status: fromState, timeStamp });
	}
	const fromStatus = labelMachinePower(data?.machinePowerStatus?.status);
	if (fromStatus) {
		signals.push({ status: fromStatus, timeStamp: data?.machinePowerStatus?.timeStamp ?? null });
	}
	const event = latestMachinePowerEvent(data?.[MACHINE_POWER_EVENT_KEY]);
	const fromEvent = labelMachinePower(event?.value);
	if (fromEvent) {
		signals.push({ status: fromEvent, timeStamp: event?.timeStamp ?? null });
	}
	const dated = signals.filter((signal) => signal.timeStamp != null);
	if (dated.length) {
		dated.sort((a, b) => b.timeStamp - a.timeStamp);
		return dated[0];
	}
	const known = signals.find((signal) => signal.status === "ON" || signal.status === "OFF");
	return known || signals[0] || { status: "UNKNOWN", timeStamp: null };
}

export function shouldRenderKitchenEvent(systemEventKey, events) {
	if (systemEventKey === MACHINE_POWER_EVENT_KEY) {
		return false;
	}
	return Array.isArray(events) && events.length > 0;
}
